import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';


export default function Privacy() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-50 tracking-tighter mb-8">
            Gizlilik Politikası
          </h1>
          <p className="text-sm text-foreground-500 mb-8">
            Son güncelleme: 7 Ağustos 2026
          </p>

          <div className="space-y-8 text-foreground-300 leading-relaxed">
            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">1. Toplanan Bilgiler</h2>
              <p className="text-sm md:text-base">
                BIFF Digital olarak, web sitemiz üzerinden iletişim formu aracılığıyla ad soyad, e-posta adresi ve mesaj içeriği gibi bilgileri toplarız. Bu bilgiler yalnızca sizinle iletişime geçmek ve hizmet taleplerinizi değerlendirmek amacıyla kullanılır.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">2. Bilgilerin Kullanımı</h2>
              <p className="text-sm md:text-base">
                Topladığımız kişisel veriler; hizmetlerimiz hakkında bilgi vermek, teklif hazırlamak, sözleşme süreçlerini yürütmek ve yasal yükümlülüklerimizi yerine getirmek amacıyla işlenir. Verileriniz hiçbir şekilde üçüncü taraflarla paylaşılmaz veya satılmaz.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">3. Çerezler (Cookies)</h2>
              <p className="text-sm md:text-base">
                Web sitemiz, kullanıcı deneyimini iyileştirmek ve site trafiğini analiz etmek amacıyla çerezler kullanabilir. Çerez tercihlerinizi tarayıcı ayarlarınızdan yönetebilirsiniz. Detaylı bilgi için Çerez Politikası sayfamızı ziyaret edin.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">4. Veri Güvenliği</h2>
              <p className="text-sm md:text-base">
                Kişisel verilerinizin güvenliğini sağlamak için teknik ve idari önlemler alıyoruz. Verileriniz yetkisiz erişime, değiştirilmeye veya ifşaya karşı korunmaktadır.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">5. Haklarınız</h2>
              <p className="text-sm md:text-base">
                6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında; verilerinize erişme, düzeltme, silme ve işlenmesine itiraz etme haklarına sahipsiniz. Talepleriniz için <strong>info@biffdigital.com</strong> adresinden bizimle iletişime geçebilirsiniz.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">6. İletişim</h2>
              <p className="text-sm md:text-base">
                Gizlilik politikamızla ilgili sorularınız için:
                <br />
                <strong>BIFF Digital</strong>
                <br />
                Söğütözü Cad. No: 2 Koç Kuleleri C Blok 17, Çankaya/Ankara
                <br />
                E-posta: info@biffdigital.com
                <br />
                Telefon: +90 555 710 1968
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}